import { useCallback, useMemo } from 'react';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import keysIn from 'lodash/keysIn';
import pick from 'lodash/pick';
import startsWith from 'lodash/startsWith';
import uniq from 'lodash/uniq';
import { validateForm } from 'helpers/form';
import DefaultValidator from 'libs/Validator';
import { useAction } from 'hooks';
import * as actions from './actions';
// TODO: Define types. formValues especially.
/* eslint-disable @typescript-eslint/typedef */ export const useIsFormNotCompleted = (formValues, validatorRules, { Validator = DefaultValidator } = {})=>useMemo(()=>{
        const requiredRules = {};
        const fields = keysIn(validatorRules);
        forEach(fields, (field)=>{
            if (startsWith(validatorRules[field], 'required')) {
                requiredRules[field] = 'required';
            }
        });
        const { errors } = validateForm(formValues, requiredRules, false, Validator);
        return !!errors;
    }, [
        formValues,
        validatorRules
    ]);
export const useIsPasswordValid = (formValues, validatorRules, { Validator = DefaultValidator } = {})=>{
    const password = get(formValues, 'values.password');
    return useMemo(()=>{
        const inputValidatorRules = {
            password: validatorRules.password
        };
        const { errors } = Validator.run({
            password
        }, inputValidatorRules, false);
        return !errors;
    }, [
        password
    ]);
};
// TODO: Specify validatedValues type
export const useFormProcessing = (formName, onSubmit, { isToUnfold = false, onlyChanged = false, stopOnFirstError = true, Validator = DefaultValidator } = {})=>{
    const onProcessing = useAction(actions.startFormProcessing, formName);
    const onErrors = useAction(actions.setFormErrors, formName);
    return useCallback((formValues, validatorRules)=>{
        onProcessing();
        const { validatedValues, errors } = validateForm(formValues, validatorRules, isToUnfold, Validator, stopOnFirstError);
        onErrors(errors);
        let values = validatedValues;
        if (onlyChanged) {
            const originalValues = get(formValues, 'originalValues', {});
            const changedValuesKeys = uniq(keysIn(originalValues).map((k)=>k.split('.')[0]));
            values = pick(validatedValues, changedValuesKeys);
        }
        if (!errors && onSubmit) onSubmit(values);
    }, [
        onSubmit
    ]);
};
export const useValidatedSetFormValue = (formName, validatorRules, { stopOnFirstError = true, Validator = DefaultValidator } = {})=>{
    const setFormValue = useAction(actions.setFormValue, formName);
    return useCallback((input)=>{
        const inputValidatorRules = {
            [input.id]: validatorRules[input.id]
        };
        const { errors } = Validator.run({
            [input.id]: input.value
        }, inputValidatorRules, stopOnFirstError);
        setFormValue(input, errors);
    }, [
        validatorRules
    ]);
};
